export enum RequestContentTypeEnum {
  ArrayBuffer = 'arraybuffer',
  JSON = 'application/json',
  MultipartFormData = 'multipart/form-data',
  FormUrlEncoded = 'application/x-www-form-urlencoded'
}
